"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleItemWorkflow = void 0;
var interfaces_1 = require("@augloop/interfaces");
var SingleItemWorkflow = /** @class */ (function () {
    function SingleItemWorkflow(id, opts) {
        var _a, _b;
        this.kind = interfaces_1.WorkflowKind.SingleItem;
        this.id = id;
        if (opts) {
            this.inputTypes = (_a = opts.inputTypes) !== null && _a !== void 0 ? _a : this.inputTypes;
            this.outputTypes = (_b = opts.outputTypes) !== null && _b !== void 0 ? _b : this.outputTypes;
        }
    }
    SingleItemWorkflow.create = function (id) {
        return new SingleItemWorkflow(id);
    };
    SingleItemWorkflow.prototype.setInputTypes = function (itemTypes) {
        this.inputTypes = itemTypes;
        return this;
    };
    SingleItemWorkflow.prototype.setOutputTypes = function (outputTypes) {
        this.outputTypes = outputTypes;
        return this;
    };
    SingleItemWorkflow.prototype.setLambdaType = function (ctr) {
        this.factory = function () { return new ctr(); };
        return this;
    };
    SingleItemWorkflow.prototype.setLambda = function (lambda, initLambda) {
        this.factory = function () { return ({
            init: initLambda ? initLambda : function (_) { return Promise.resolve(); },
            execute: lambda,
            dispose: function () { }
        }); };
        return this;
    };
    return SingleItemWorkflow;
}());
exports.SingleItemWorkflow = SingleItemWorkflow;
//# sourceMappingURL=single-item-workflow.js.map